export const MANAGER_DASHBOARD_TITLE = 'Manager Dashboard';
export const MANAGER_DASHBOARD_PRULEADS_TITLE = 'PRULeads';

export const MANAGER_DASHBOARD_BASE_PATH = `/manager-dashboard`;
export const MANAGER_DASHBOARD_PRULEADS_PATH = `/pruleads`;

export const MANAGER_DASHBOARD_PRULEADS_NAMESPACE = 'MANAGER_DASHBOARD_PRULEADS';
